<template>
  <div>

    <!-- HOME SLIDERS -->
    <section class="mb-5" v-if="homeSliders && homeSliders.length > 0">
      <div class="container">
        <div>
          <Carousel
            :sliders="homeSliders"
          />
        </div>
      </div>

    </section> <!-- END HOME SLIDERS -->

    <!-- LISTS -->
    <section
      class="mb-5"
      v-for="list in homeLists"
      :key="list.id"
    >
      <div class="container">
        <h2 class="font-weight-bold font-size-medium text-center text-md-left">{{list.name}}</h2>
        <div v-if="listsContent[list.id] && listsContent[list.id].content.length > 0">
          <ListThumbCarousel
            :content="listsContent[list.id].content"
          />
          <div class="mt-4 text-center separator-btn">
            <div class="btnWrap">
              <router-link
                class="btn btn-outline-color2 btn-lg"
                :to="{ name: 'lists.custom.show', params: { slug: list ? list.slug : 'slug' } }"
              >
                Ver todos
              </router-link>
            </div>
          </div>
        </div>
        <p
          class="text-center mt-3"
          v-else-if="!loaderLists"
        >Não foi encontrado conteúdo para esta lista</p>
        <Loader
          color="color2"
          size="big"
          v-else
        />
      </div>

    </section> <!-- END LISTS -->

    <!-- SCRIV PRO FEED -->
    <!-- <section v-if="scrivProPosts.length > 0" class="mb-5">
      <div class="container">
        <h2 class="font-weight-bold font-size-medium text-center text-md-left">Novidades de usuários Scriv Pro</h2>
        <div>
          <PostThumbCarousel
            :posts="scrivProPosts"
          />
          <div class="mt-4 text-center separator-btn">
            <div class="btnWrap">
              <router-link
                class="btn btn-outline-color2 btn-lg"
                :to="{ name: 'feed.show', params: { type: 'scriv-pro' } }"
              >
                Ver todos
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- END SCRIV PRO FEED -->

    <!-- LATEST FEED -->
    <section class="mb-5">
      <div class="container">
        <h2 class="font-weight-bold font-size-medium text-center text-md-left">Publicações mais recentes</h2>
        <div v-if="latestPosts.length > 0">
          <PostThumbCarousel
            :posts="latestPosts"
          />
          <div class="mt-4 text-center separator-btn">
            <div class="btnWrap">
              <router-link
                class="btn btn-outline-color2 btn-lg"
                :to="{ name: 'feed.show', params: { type: 'latest' } }"
              >
                Ver todos
              </router-link>
            </div>
          </div>
        </div>
        <p
          class="text-center mt-3"
          v-else-if="!loaderLatest"
        >Não foi encontrado nenhum texto</p>
        <Loader
          color="color2"
          size="big"
          v-else
        />
      </div>

    </section> <!-- END LATEST FEED -->

    <!-- FOLLOWS FEED -->
    <section v-if="followingPosts.length > 0" class="mb-5">
      <div class="container">
        <h2 class="font-weight-bold font-size-medium text-center text-md-left">Novidades de quem você segue</h2>
        <div>
          <PostThumbCarousel
            :posts="followingPosts"
          />
          <div class="mt-4 text-center separator-btn">
            <div class="btnWrap">
              <router-link
                class="btn btn-outline-color2 btn-lg"
                :to="{ name: 'feed.following' }"
              >
                Ver todos
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section> <!-- END FOLLOWS FEED -->

    <!-- GROUPS FEED -->
    <section v-if="groupsPosts.length > 0" class="mb-5">
      <div class="container">
        <h2 class="font-weight-bold font-size-medium text-center text-md-left">Novidades das suas comunidades</h2>
        <div>
          <PostThumbCarousel
            :posts="groupsPosts"
          />
          <div class="mt-4 text-center separator-btn">
            <div class="btnWrap">
              <router-link
                class="btn btn-outline-color2 btn-lg"
                :to="{ name: 'feed.groups' }"
              >
                Ver todos
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section> <!-- END GROUPS FEED -->

    <!-- TRENDING FEED -->
    <section>
      <div class="container">
        <h2 class="font-weight-bold font-size-medium text-center text-md-left">Conteúdo em destaque no momento</h2>
        <div v-if="trendingPosts.length > 0">
          <PostThumbCarousel
            :posts="trendingPosts"
          />
          <div class="mt-4 text-center separator-btn">
            <div class="btnWrap">
              <router-link
                class="btn btn-outline-color2 btn-lg"
                :to="{ name: 'feed.show', params: { type: 'trending' } }"
              >
                Ver todos
              </router-link>
            </div>
          </div>
        </div>
        <p
          class="text-center mt-3"
          v-else-if="!loaderTrending"
        >Não foi encontrado nenhum texto</p>
        <Loader
          color="color2"
          size="big"
          v-else
        />
      </div>

    </section> <!-- END TRENDING FEED -->

  </div>
</template>

<script>

// import Button from '@/components/common/Button/Button.vue'
import Loader from '@/components/common/Loader/Loader.vue'
import Carousel from '@/components/common/Carousel/Carousel.vue'
import PostThumbCarousel from '@/components/post/PostThumbCarousel.vue'
import ListThumbCarousel from '@/components/lists/ListThumbCarousel.vue'

import FeedService from '@/modules/feed/services/feed-service'
import ListService from '@/modules/lists/services/lists-service'
import SliderService from '@/modules/sliders/services/slider-service'

export default {
  components: {
    // Button,
    Carousel,
    PostThumbCarousel,
    ListThumbCarousel,
    Loader
  },
  data () {
    return {
      homeSliders: [],
      followingPosts: [],
      latestPosts: [],
      homeLists: [],
      trendingPosts: [],
      groupsPosts: [],
      scrivProPosts: [],
      listsContent: {},
      loaderLists: false,
      loaderFollowing: false,
      loaderLatest: false,
      loaderGroups: false,
      loaderScrivPro: false,
      followingPostsPage: 1,
      latestPostsPage: 1,
      latestTrendingPage: 1,
      latestGroupsPage: 1,
      latestScrivProPage: 1
    }
  },
  metaInfo: {
    title: 'Home'
  },
  created () {
    this.getFeedPosts()
    this.getLatestPosts()
    this.getTrendingPosts()
    this.getGroupsPosts()
    this.getCustomLists()
    this.getScrivProPosts()
    this.getSliders()
  },
  methods: {
    async getSliders () {
      try {
        const sliders = await SliderService.getSliders({ type: 'home' })
        this.homeSliders = [...this.homeSliders, ...sliders]
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async getFeedPosts () {
      this.loaderFollowing = true
      try {
        const posts = await FeedService.getFeedPosts({ type: 'following', page: this.followingPostsPage, items: 12, unique: true })
        this.followingPosts = [...this.followingPosts, ...posts]
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderFollowing = false
    },
    async getLatestPosts () {
      this.loaderLatest = true
      try {
        const posts = await FeedService.getFeedPosts({ type: 'latest', page: this.latestPostsPage, items: 12, unique: true })
        this.latestPosts = [...this.latestPosts, ...posts]
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderLatest = false
    },
    async getTrendingPosts () {
      this.loaderTrending = true
      try {
        const posts = await FeedService.getFeedPosts({ type: 'trending', page: this.latestTrendingPage, items: 12, unique: true })
        this.trendingPosts = [...this.trendingPosts, ...posts]
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderTrending = false
    },
    async getGroupsPosts () {
      this.loaderGroups = true
      try {
        const posts = await FeedService.getFeedPosts({ type: 'groups', page: this.latestGroupsPage, items: 12 })
        this.groupsPosts = [...this.groupsPosts, ...posts]
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderGroups = false
    },
    async getScrivProPosts () {
      this.loaderScrivPro = true
      try {
        const posts = await FeedService.getFeedPosts({ type: 'scriv_pro', page: this.latestScrivProPage, items: 12, unique: true })
        this.scrivProPosts = [...this.scrivProPosts, ...posts]
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderScrivPro = false
    },
    async getCustomLists () {
      try {
        const lists = await ListService.getHomeLists({ page: 1 })
        this.homeLists = lists
        for (let index = 0; index < lists.length; index++) {
          await this.getCustomListContent(lists[index].id)
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async getCustomListContent (id) {
      this.loaderLists = true
      try {
        let page = 1
        if (this.listsContent[id]) {
          page = this.listsContent[id].page
        }
        const content = await ListService.getContent({ listId: id, page: page })
        const obj = {
          page: page,
          content: this.listsContent[id] ? [...this.listsContent[id].content, ...content] : content
        }
        this.listsContent[id] = obj
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderLists = false
    },
    async loadMoreListContent (id) {
      if (this.listsContent[id]) {
        this.listsContent[id].page++
      }
      await this.getCustomListContent(id)
    }
  }
}
</script>

<style lang="scss" scoped>

#banners {
  margin-top: -3rem !important;
  @include desktop {
    margin-top: 0 !important;
  }

  .container {
    padding: 0;

    @include desktop {
      padding: 0 15px;
    }
  }
}

.separator-btn {
  position: relative;

  &::before {
    @include tablet {
      content: '';
    }
    width: 80%;
    height: 1px;
    background: rgba(0,0,0,0.1);
    position: absolute;
    top: 50%;
    left: 10%;
  }

  .btnWrap {

    @include tablet {
      background: #F6F6F6;
      position: relative;
      display: inline-block;
      z-index: 2;
      padding: 0 25px;
    }
  }
}

</style>
